import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s Talk About Your Project</h2>
                        </div>
                      <p>We’re eager to discuss and understand your custom software development needs. Whether you have a detailed plan or just a concept, we're ready to transform it into a practical and tailored solution.</p>
                       <p>Our services prioritize simplicity, effectiveness, and collaboration. Ready to move forward? Let's talk about your project—fill out the form and click "Get In Touch" to get started.</p>
                        </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;